import { AppList } from '@ui/applications';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from './DetailSubsection';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { useSonarObjectReference } from '@hooks';
export const IngestedBySection = ({ sonarObjectId }) => {
    const { ingestedBy } = useSonarObjectReference(sonarObjectId);
    return (React.createElement(FeatureBoundary, { feature: FeatureFlag.DataSecurityDashboard },
        React.createElement(DetailSubsection, { className: 'inline-metadata', count: ingestedBy.length, title: COPY_SPECIFIC.READ_BY },
            React.createElement(AppList, { appIds: ingestedBy, direction: 'horizontal' }))));
};
